import {ServiceModel} from './service.model';
import {BaseModel} from '../../base/models/base-model.model';

export class ServicesCombinationModel extends BaseModel {
  private _services?: Array<ServiceModel>;

  constructor(id?: string, services?: Array<ServiceModel>) {
    super();
    this._id = id;
    this._services = services;
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get services(): Array<ServiceModel> {
    return this._services;
  }

  set services(value: Array<ServiceModel>) {
    this._services = value;
  }
}
